import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export const TRANSLATION_MODULES: string[] = [
  'common',
  'menu',
  'login',
  'attendance',
  'employee',
  'dashboard'
];

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private modules: string[] = TRANSLATION_MODULES
  ) {}

  getTranslation(lang: string): Observable<any> {
    return forkJoin(
      this.modules.map(mod =>
        this.http.get(`./assets/i18n/${lang}/${mod}.json`)
      )
    ).pipe(
      map(responses => Object.assign({}, ...responses))
    );
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new MultiTranslateHttpLoader(http);
}
